import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {AppSettings} from '../../../app-settings';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataManagementService} from '../../services/data-management.service';
import {AuthenticationService} from '../../services/authentication.service';
import {Constants} from '../../constants';

@Component({
  selector: 'app-processing-output',
  templateUrl: './processing-output.component.html',
  styleUrls: ['./processing-output.component.css']
})
export class ProcessingOutputComponent implements OnInit {

  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  processingOutput;
  rounds;
  data: object;
  selectUndefinedOptionValue = '0';
  downloadRoundWiseProcessingOutput = AppSettings.DOWNLOAD_ROUND_WISE_PROCESSING_OUTPUT;
  outgoingRoundId = '0';
  token;
  errorMessage: string = undefined;

  constructor(private modal: NgbModal,
              private dmService: DataManagementService,
              private authenticationService: AuthenticationService) {
  }

  getRoundsFilter(): void {
    this.dmService.getAll(Constants.ROUNDS_FILTER)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.rounds = response.data;
                if (this.rounds.length > 0) {
                  this.outgoingRoundId = this.rounds[0].outgoing_round_id;
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getProcessingOutput() {
    this.dmService.getOne(Constants.PROCESSING_OUTPUT, this.outgoingRoundId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.processingOutput = response.data;
                if (this.processingOutput.length === 0) {
                  this.errorMessage = 'There is no data available for processing output.';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                this.errorMessage = 'Failed to load processing output. Please contact support team';
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  ngOnInit() {
    this.getProcessingOutput();
    this.getRoundsFilter();
    this.token = '?token=' + this.authenticationService.getToken();
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}

